import { FlexColumn } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import RuleList from 'alertRules/components/RuleList';
import { RuleAccordionProps } from 'alertRules/components/RuleAccordion';

type Props = {
  data: RuleAccordionProps[];
  isLoading: boolean;
  isOrderBasedMatching?: boolean;
  onReorder?: (orderedIds: string[]) => void;
  isReorderDisabled?: boolean;
};

const AlertRulesList = ({
  data,
  isLoading,
  isOrderBasedMatching,
  onReorder,
  isReorderDisabled,
}: Props) => (
  <FlexColumn sx={{ gap: 2 }}>
    {isOrderBasedMatching && data.length > 0 && (
      <Typography variant="body2" color="text.secondary">
        Rules are checked from top to bottom. An alert is sent by the first rule
        that matches it; later rules only see alerts that earlier rules
        didn&apos;t match.
      </Typography>
    )}
    <RuleList
      data={data}
      isLoading={isLoading}
      emptyStateTitle="Create your first alert rule"
      emptyStateDescription="Ex: send all failure alerts to #failure-alerts-channel"
      onReorder={onReorder}
      isReorderDisabled={isReorderDisabled}
    />
  </FlexColumn>
);

export default AlertRulesList;
